exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".changeCourseContainer---1L3t9 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding: 75px 0;\n  outline: none;\n  position: relative; }\n\n.header---1cqP4 {\n  width: 90%;\n  min-height: 22px;\n  margin: 33px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 1.2em;\n  text-align: center; }\n\n.header---1cqP4 span {\n    color: #32a8a7; }\n\n.description---1ZgjK {\n  margin-bottom: 20px;\n  font-size: 18px;\n  color: #4e5c67;\n  line-height: 1.3em; }\n\n.icon---3GxB9 {\n  width: 80px;\n  height: 75px; }\n\n.buttons---6HaB7 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.buttons---6HaB7 > div {\n    margin: 5px; }\n", ""]);

// exports
exports.locals = {
	"changeCourseContainer": "changeCourseContainer---1L3t9",
	"header": "header---1cqP4",
	"description": "description---1ZgjK",
	"icon": "icon---3GxB9",
	"buttons": "buttons---6HaB7"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/change-course/confirm.scss
// module id = 1136
// module chunks = 3